<div class="mat-elevation-z8 table-container" (scroll)="onTableScroll($event)">
    <table mat-table [dataSource]="dataSource">
        <!-- Company Name Column -->
        <ng-container matColumnDef="Company Name">
        <th mat-header-cell *matHeaderCellDef> Company Name </th>
        <td mat-cell *matCellDef="let element"> {{ element.customerName }} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns;"
        (click)="onRowClicked(row)"
        style="cursor: pointer;">
        </tr>
    </table>
    <div class="invisible">
        <mat-paginator (page)="(0); onPageChanged($event)"
        [length]="resultsLength"
        [pageSizeOptions]="[10, 25, 50]"
        [pageSize]="pageSize"></mat-paginator>
    </div>
</div>